import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ASFCourseSession } from "../../model/autovioCalendarEvents";
import { EventDialogHeader } from "../EventDialog";
import { ShortEventHistory } from "./ShortEventHistory";
import { DialogCloseButton } from "../../misc/DialogCloseButton";
import { Column } from "../../misc/Column";
import { ASFCourseSessionDetails } from "./EventInfoCard";

export function StudentASFCourseSessionDialog(props: { event: ASFCourseSession; onClose: () => void }) {
  const { event, onClose } = props;
  return (
    <Dialog open onClose={onClose} maxWidth="lg">
      <DialogTitle>
        <EventDialogHeader event={event} mode="view" closeDialog={onClose} />
      </DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <ShortEventHistory event={event} />
        <Column spacing="0.5em">
          <ASFCourseSessionDetails event={event} />
        </Column>
      </DialogContent>
    </Dialog>
  );
}
